import {
  subDays,
  startOfDay,
  endOfDay,
  startOfMonth,
  endOfMonth,
  subMonths,
  startOfYear,
  endOfYear,
  subYears,
} from 'date-fns';
import { QuizResponseOptions } from '../types';

export const MAX_QUIZ_ROUND = 5;

const TODAY = new Date();

export const DATE_RANGES = {
  today: {
    label: 'Today',
    start: startOfDay(TODAY),
    end: endOfDay(TODAY),
  },
  yesterday: {
    label: 'Yesterday',
    start: startOfDay(subDays(TODAY, 1)),
    end: endOfDay(subDays(TODAY, 1)),
  },
  last7Days: {
    label: 'Last 7 Days',
    start: startOfDay(subDays(TODAY, 5)),
    end: TODAY,
  },
  thisMonth: {
    label: 'This Month',
    start: startOfMonth(TODAY),
    end: TODAY,
  },
  lastMonth: {
    label: 'Last Month',
    start: startOfMonth(subMonths(TODAY, 1)),
    end: endOfMonth(subMonths(TODAY, 1)),
  },
  thisYear: {
    label: 'This Year',
    start: startOfYear(TODAY),
    end: endOfDay(TODAY),
  },
  lastYear: {
    label: 'Last Year',
    start: startOfYear(subYears(TODAY, 1)),
    end: endOfYear(subYears(TODAY, 1)),
  },
  allTime: {
    label: 'All Time',
    start: new Date(2000, 0, 1),
    end: endOfDay(TODAY),
  },
} as const;

export const responseData: QuizResponseOptions = {
  yes_no: [
    { id: 'yes', option: 'Yes' },
    { id: 'no', option: 'No' },
    { id: 'not_sure', option: 'Not sure' },
  ],
  date: [],
  text: [],
  multiple_choice: [],
};

export const errMsg = {
  'auth/email-already-in-use': 'The email address is already in use.',
  'auth/invalid-credential': 'The email or password is incorrect.',
};

export const CLAIM_CTA_TYPE = {
  EXTERNAL_LINK: 'EXTERNAL_LINK',
  INTERNAL_LINK: 'INTERNAL_LINK',
  PHONE_CALL: 'PHONE_CALL',
};

export const CLAIM_STATUS = {
  SETTLED: 'settled',
  PENDING: 'pending',
  ACTIVE: 'active',
  CLOSED: 'closed',
};

export const CAMPAIGN_STATUS_COLORS = {
  active: 'bg-emerald-500/10 text-emerald-400',
  paused: 'bg-amber-500/10 text-amber-400',
  archived: 'bg-gray-500/10 text-gray-400',
  pending: 'bg-kpi-spend/10 text-kpi-spend',
};

export const TIMEZONES = [
  { label: 'Eastern Time (ET)', value: 'America/New_York' },
  { label: 'Central Time (CT)', value: 'America/Chicago' },
  { label: 'Mountain Time (MT)', value: 'America/Denver' },
  { label: 'Pacific Time (PT)', value: 'America/Los_Angeles' },
  { label: 'Alaska Time (AT)', value: 'America/Anchorage' },
  { label: 'Hawaii-Aleutian Time (HAT)', value: 'Pacific/Honolulu' },
  { label: 'Greenwich Mean Time (GMT)', value: 'Europe/London' },
  { label: 'Coordinated Universal Time (UTC)', value: 'UTC' },
  { label: 'Central European Time (CET)', value: 'Europe/Paris' },
  { label: 'Eastern European Time (EET)', value: 'Europe/Athens' },
  { label: 'Australian Eastern Time (AET)', value: 'Australia/Sydney' },
  { label: 'Australian Central Time (ACT)', value: 'Australia/Darwin' },
  { label: 'Australian Western Time (AWT)', value: 'Australia/Perth' },
  { label: 'Japan Standard Time (JST)', value: 'Asia/Tokyo' },
  { label: 'China Standard Time (CST)', value: 'Asia/Shanghai' },
  { label: 'India Standard Time (IST)', value: 'Asia/Kolkata' },
  { label: 'Moscow Time (MSK)', value: 'Europe/Moscow' },
  { label: 'Brazil Standard Time (BRT)', value: 'America/Sao_Paulo' },
  { label: 'Argentina Time (ART)', value: 'America/Argentina/Buenos_Aires' },
  { label: 'New Zealand Standard Time (NZST)', value: 'Pacific/Auckland' },
  { label: 'South Africa Standard Time (SAST)', value: 'Africa/Johannesburg' },
  { label: 'Pakistan Standard Time (PKT)', value: 'Asia/Karachi' },
  { label: 'Gulf Standard Time (GST)', value: 'Asia/Dubai' },
  { label: 'Arabian Standard Time (AST)', value: 'Asia/Riyadh' },
  { label: 'Singapore Time (SGT)', value: 'Asia/Singapore' },
  { label: 'Philippine Time (PST)', value: 'Asia/Manila' },
  { label: 'Korea Standard Time (KST)', value: 'Asia/Seoul' },
  { label: 'Indonesia Western Time (WIB)', value: 'Asia/Jakarta' },
  { label: 'Malaysia Time (MYT)', value: 'Asia/Kuala_Lumpur' },
  { label: 'Egypt Standard Time (EGT)', value: 'Africa/Cairo' },
];

